import sparketTutorial4 from "assets/sparket-tutorial/sparket-tutorial-4.png";
import BlockyBlockyMediumText from "components/custom-texts/blocky-medium-text";
import { Link } from "react-router-dom";
import { useAppDispatch } from "state/hooks";
import styles from "./styles.module.css";
import { close } from "state/slices/sparket-tutorial-slice";
import { Button } from "react-bootstrap";
import { secondaryColor } from "utils/constants";
import BlockyBoldText from "../../custom-texts/blocky-bold-text";

const PageOneContent = () => {
  const dispatch = useAppDispatch();
  return (
    <div className={styles.pageContentContainer}>
      <BlockyBlockyMediumText className={styles.topText}>
        The odds on the pools are{" "}
        <span className={styles.bold}>not fixed until the closing time</span>,
        which is always listed on each pool.
      </BlockyBlockyMediumText>
      <img className="d-block w-100" src={sparketTutorial4} alt="First slide" />
      <BlockyBlockyMediumText className={styles.bottomText}>
        For more detailed information, please see the{" "}
        <Link
          onClick={() => dispatch(close())}
          style={{ color: "black" }}
          className={styles.bold}
          to="/help"
        >
          Help section
        </Link>
        . We always appreciate any feedback.
      </BlockyBlockyMediumText>
      <Button
        onClick={() => dispatch(close())}
        style={{
          border: "none",
          backgroundColor: secondaryColor,
        }}
      >
        <BlockyBoldText style={{ color: "black" }}>Got it!</BlockyBoldText>
      </Button>
    </div>
  );
};

export default PageOneContent;
